import { Group } from "@mantine/core";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { LanguageSwitcher } from "../../components/language-switcher";
import { Logo } from "../../components/logo";
import { ThemeToggle } from "../../components/theme-toggle";
import styles from "./auth.module.css";

export function AuthLayout({
  title,
  children,
  footer,
}: {
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className={styles.root}>
      <main className={styles.main}>
        <div className={styles.card}>
          <div className={styles.logo}>
            <Logo />
          </div>
          <h1 className={styles.title}>{title}</h1>
          {children}
          {footer ? <div className={styles.footer}>{footer}</div> : null}
        </div>
      </main>
      <footer className={styles.bottom}>
        <Group gap={4}>
          <ThemeToggle />
          <LanguageSwitcher />
        </Group>
      </footer>
    </div>
  );
}

export function AuthFooterLink({ to, label }: { to: string; label: string }) {
  return (
    <Link className={styles.link} to={to}>
      {label}
    </Link>
  );
}
